<template lang="pug">
  .page-construction
    .page-construction__img-wr
      img.page-construction__img(src="/img/content/tour.png")
    .page-construction__text Страница находится в разработке

</template>

<script>
  import '@/components/common/pageConstruction/pageConstruction.styl';

  import EventBus from '@/eventBus';

  export default {
    name: 'PageConstruction',

    components: {},

    data() {
      return {}
    },

    created() {

    },

    methods: {

    }
  }
</script>
